module.exports = __webpack_public_path__ + "static/media/user.4b666d14.svg";